import React from "react";
import { useDispatch, useSelector, useEf } from "react-redux";
import utiWhite from '../../../assets/images/utiWhite.png'

import whatsApp from "../../../assets/images/whatsApp.svg";
import facebook from "../../../assets/images/facebook.svg";
import "./Footer.css";
import { useLocation } from 'react-router-dom'
import { Container } from "@mui/material";


const Footer = (props) => {

  const isMobile = window.innerWidth <= 760
  const { isLog } = props;
  const location = useLocation();
  const loginFooter = isLog || location.pathname.includes("login");

  return (
    <div className={"footer " + (loginFooter ? 'loginFooter' : '')} >
      <Container >
        <div className="footer-warp">
          {!loginFooter && <img className="white-logo" src={utiWhite} />}
          {(!isMobile || loginFooter) &&
            <span className="desc">משרדים ראשיים ברחוב שנקר 11 מרכז עסקים שורק, ראשל”צ</span>
          }
          <div className="side-items">
            <span className="desc">884*</span>
            <a target="_blank" href="https://wa.me/972523122668">
              <img src={whatsApp} alt="whatsApp" className="header-icon" />
            </a>
            <a target="_blank" href="">
              <img src={facebook} alt="facebook" className="header-icon" />
            </a>
          </div>
          {(isMobile && !loginFooter) &&
            <div className="desc">רחוב שנקר 11 מרכז עסקים שורק, ראשל”צ</div>
          }
        </div>

      </Container>
    </div>
  );
};

export default Footer;
